import { useMutation, useQueryClient } from "react-query";
import { mutatePutFn } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export const useChangeKeyAuthorizedHost = () => {
  const queryClient = useQueryClient();
  return useMutation<any, any, any>(
    (data) => mutatePutFn(ENDPOINTS.CHANGE_KEY_AUTHORIZED_HOST, data),
    {
      onSuccess: async () => {
        queryClient.invalidateQueries([]);
      },
    }
  );
};
